import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

import vietnam100 from '../images/vietnam100.jpeg';
import vietnam103 from '../images/vietnam103.jpeg';
import vietnam104 from '../images/vietnam104.jpeg';
import vietnam105 from '../images/vietnam105.jpeg';
import vietnam106 from '../images/vietnam106.jpeg';
import vietnam107 from '../images/vietnam107.jpeg';
import vietnam108 from '../images/vietnam108.jpeg';
import vietnam109 from '../images/vietnam109.jpeg';
import vietnam110 from '../images/vietnam110.jpeg';
import vietnam111 from '../images/vietnam111.jpeg';
import vietnam112 from '../images/vietnam112.jpeg';
import vietnam113 from '../images/vietnam113.jpeg';
import vietnam114 from '../images/vietnam114.jpeg';
import vietnam115 from '../images/vietnam115.jpeg';
import vietnam116 from '../images/vietnam116.jpeg';
import vietnam117 from '../images/vietnam117.jpeg';
import vietnam118 from '../images/vietnam118.jpeg';
import vietnam119 from '../images/vietnam119.jpeg';
import vietnam120 from '../images/vietnam120.jpeg';
import vietnam121 from '../images/vietnam121.jpeg';
import vietnam122 from '../images/vietnam122.jpeg';
import vietnam123 from '../images/vietnam123.jpeg';
import vietnam124 from '../images/vietnam124.jpeg';
import vietnam125 from '../images/vietnam125.jpeg';
import vietnam1 from '../images/vietnam1.jpg';
import vietnam2 from '../images/vietnam2.jpg';
import vietnam3 from '../images/vietnam3.jpg';
import vietnam4 from '../images/vietnam4.jpg';
import vietnam5 from '../images/vietnam5.jpg';
import vietnam6 from '../images/vietnam6.jpg';
import vietnam7 from '../images/vietnam7.jpg';
import vietnam8 from '../images/vietnam8.jpg';
import vietnam9 from '../images/vietnam9.jpg';
import vietnam10 from '../images/vietnam10.jpg';
import vietnam11 from '../images/vietnam11.jpg';
import vietnam12 from '../images/vietnam12.jpg';
import vietnam13 from '../images/vietnam13.jpg';
import vietnam14 from '../images/vietnam14.jpg';
import vietnam15 from '../images/vietnam15.jpg';
import vietnam16 from '../images/vietnam16.jpg';
import vietnam17 from '../images/vietnam17.jpg';
import vietnam18 from '../images/vietnam18.jpg';
import vietnam19 from '../images/vietnam19.jpg';
import vietnam20 from '../images/vietnam20.jpg';
import vietnam21 from '../images/vietnam21.jpg';
import vietnam22 from '../images/vietnam22.jpg';
import vietnam23 from '../images/vietnam23.jpg';
import vietnam24 from '../images/vietnam24.jpg';
import vietnam25 from '../images/vietnam25.jpg';
import vietnam26 from '../images/vietnam26.jpg';
import vietnam27 from '../images/vietnam27.jpg';
import vietnam28 from '../images/vietnam28.jpg';
import vietnam29 from '../images/vietnam29.jpg';
import vietnam30 from '../images/vietnam30.jpg';
import vietnam31 from '../images/vietnam31.jpg';
import vietnam32 from '../images/vietnam32.jpg';
import vietnam33 from '../images/vietnam33.jpg';
import vietnam34 from '../images/vietnam34.jpg';
import vietnam35 from '../images/vietnam35.jpg';
import vietnam36 from '../images/vietnam36.jpg';
import vietnam37 from '../images/vietnam37.jpg';
import vietnam38 from '../images/vietnam38.jpg';
import vietnam39 from '../images/vietnam39.jpg';
import vietnam40 from '../images/vietnam40.jpg';
import vietnam41 from '../images/vietnam41.jpg';
import vietnam42 from '../images/vietnam42.jpg';
import vietnam43 from '../images/vietnam43.jpg';
import vietnam44 from '../images/vietnam44.jpg';
import vietnam45 from '../images/vietnam45.jpg';
import vietnam46 from '../images/vietnam46.jpg';
import vietnam47 from '../images/vietnam47.jpg';
import vietnam48 from '../images/vietnam48.jpg';
import vietnam49 from '../images/vietnam49.jpg';
import vietnam50 from '../images/vietnam50.jpg';
import vietnam51 from '../images/vietnam51.jpg';
import vietnam52 from '../images/vietnam52.jpg';
import vietnam53 from '../images/vietnam53.jpg';
import vietnam54 from '../images/vietnam54.jpg';
import vietnam55 from '../images/vietnam55.jpg';
import vietnam56 from '../images/vietnam56.jpg';
import vietnam57 from '../images/vietnam57.jpg';
import vietnam58 from '../images/vietnam58.jpg';
import vietnam59 from '../images/vietnam59.jpg';
import vietnam60 from '../images/vietnam60.jpg';
import vietnam61 from '../images/vietnam61.jpg';
import vietnam62 from '../images/vietnam62.jpg';
import vietnam63 from '../images/vietnam63.jpg';
import vietnam64 from '../images/vietnam64.jpg';
import vietnam65 from '../images/vietnam65.jpg';
import vietnam66 from '../images/vietnam66.jpg';
import vietnam67 from '../images/vietnam67.jpg';
import vietnam68 from '../images/vietnam68.jpg';
import vietnam69 from '../images/vietnam69.jpg';
import vietnam70 from '../images/vietnam70.jpg';
import vietnam71 from '../images/vietnam71.jpg';
import vietnam72 from '../images/vietnam72.jpg';
import vietnam73 from '../images/vietnam73.jpg';
import vietnam74 from '../images/vietnam74.jpg';
import vietnam75 from '../images/vietnam75.jpg';

function Vietnam() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images - vietnam100-125 first, then vietnam1-75
  const photos = [
    vietnam100, vietnam103, vietnam104, vietnam105, vietnam106, vietnam107, vietnam108, vietnam109,
    vietnam110, vietnam111, vietnam112, vietnam113, vietnam114, vietnam115, vietnam116, vietnam117, vietnam118, vietnam119,
    vietnam120, vietnam121, vietnam122, vietnam123, vietnam124, vietnam125,
    vietnam1, vietnam2, vietnam3, vietnam4, vietnam5, vietnam6, vietnam7, vietnam8, vietnam9, vietnam10,
    vietnam11, vietnam12, vietnam13, vietnam14, vietnam15, vietnam16, vietnam17, vietnam18, vietnam19, vietnam20,
    vietnam21, vietnam22, vietnam23, vietnam24, vietnam25, vietnam26, vietnam27, vietnam28, vietnam29, vietnam30,
    vietnam31, vietnam32, vietnam33, vietnam34, vietnam35, vietnam36, vietnam37, vietnam38, vietnam39, vietnam40,
    vietnam41, vietnam42, vietnam43, vietnam44, vietnam45, vietnam46, vietnam47, vietnam48, vietnam49, vietnam50,
    vietnam51, vietnam52, vietnam53, vietnam54, vietnam55, vietnam56, vietnam57, vietnam58, vietnam59, vietnam60,
    vietnam61, vietnam62, vietnam63, vietnam64, vietnam65, vietnam66, vietnam67, vietnam68, vietnam69, vietnam70,
    vietnam71, vietnam72, vietnam73, vietnam74, vietnam75
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇻🇳 Vietnam 2025 🇻🇳</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Vietnam ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Vietnam;